import React from 'react';
import { BaileyStill } from '../../agent/bailey/BaileyAvatar';
import { hapticTick } from '../../../_utils/haptics';
import { useSetup, openSetup } from './SetupContext';
import { minutesLeftLabel } from './setupPlan';

/**
 * Set up with Bailey, as the featured card at the top of Settings, while
 * setup is still to finish. The same charcoal story card as "Import your
 * data" (which takes its place once setup is done).
 */

/**
 * Whether Settings should feature setup rather than the import card. Not
 * once it's done, and not where it isn't offered: a salon that went live
 * before Bailey's setup existed, or an established one (setupEligible:
 * false from the server) that never started it, isn't sent back through it.
 */
export function useSetupFeatured() {
  const setup = useSetup();
  if (!setup || !setup.enabled || !setup.offered || setup.total === 0) return false;
  return setup.state.status !== 'done';
}

export default function SetupHero() {
  const setup = useSetup();
  if (!setup) return null;
  const { chapters, statusOf, doneCount, total, minutesLeft, state } = setup;
  const started = state.status !== 'new' || doneCount > 0;
  const later = chapters.filter((c) => statusOf(c.id) === 'skipped').length;
  const next = chapters.find((c) => statusOf(c.id) !== 'done');
  const pct = total ? doneCount / total : 0;
  const r = 30;
  const c = 2 * Math.PI * r;
  return (
    <button type="button" className="su-hero" onClick={() => { hapticTick(); openSetup({}); }}>
      <span className="su-hero-text">
        <span className="su-hero-eyebrow">Set up with Bailey</span>
        <span className="su-hero-h1">{started ? `${doneCount} of ${total} done` : 'Let’s get you ready'}</span>
        <span className="su-hero-h2">{minutesLeftLabel(minutesLeft).replace(' left', ' to go')}{later ? `, ${later} saved for later` : ''}.</span>
        {next && started && <span className="su-hero-p">Next up: {next.long}</span>}
        <span className="su-hero-bar" aria-hidden="true">
          {chapters.map((ch) => <i key={ch.id} className={statusOf(ch.id) === 'done' ? 'is-done' : statusOf(ch.id) === 'skipped' ? 'is-later' : ''} />)}
        </span>
      </span>
      <span className="su-hero-face" aria-hidden="true">
        <span className="su-hero-facein"><BaileyStill /></span>
        <svg viewBox="0 0 72 72">
          <circle cx="36" cy="36" r={r} stroke="rgba(255,255,255,.14)" />
          <circle cx="36" cy="36" r={r} stroke="#5CE1B9" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)} transform="rotate(-90 36 36)" />
        </svg>
      </span>
      <span className="su-hero-cta">{started ? 'Continue with Bailey' : 'Start with Bailey'}</span>
    </button>
  );
}
